import { render, staticRenderFns } from "./TelegramDashboard.vue?vue&type=template&id=7c09266f&scoped=true"
import script from "./TelegramDashboard.vue?vue&type=script&lang=js"
export * from "./TelegramDashboard.vue?vue&type=script&lang=js"
import style0 from "./TelegramDashboard.vue?vue&type=style&index=0&id=7c09266f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09266f",
  null
  
)

export default component.exports